import React from 'react';
import { EditMerchandisingRuleContainer } from './EditMerchRuleContainer';
import { CollapseDrawer } from '../CollapseDrawer/CollapseDrawer';
import { useEditMerchRule } from '../../hooks';
import { useIsFeaturePermitted } from '../../../../hooks';
import { useEditCategoryPage } from '../EditCategoryPage';
import { useNavigateToVisualEditorRoute } from '../../hooks/useNavigateToVisualEditorRoute';
import { useGetSelectedMerchRule } from '../SideMenu/useGetSelectedMerchRule';
import { ShopFeature } from '../../../../app-types';
import { PermittedRouteMap } from '../../../../app-routes';
import { Mode } from '../../types/mode';
import { ShopFeatureToggles } from '../../../../services/src/service/types/shops';

interface Props {
  shopId: number;
  permittedRouteMap: PermittedRouteMap;
  className: string;
  featureToggles: ShopFeatureToggles;
}

export const EditMerchandisingRule = ({
  shopId,
  permittedRouteMap,
  className,
  featureToggles,
}: Props): JSX.Element | null => {
  const {
    submitEditMerchRuleForm,
    closeMerchandisingRulesDrawer,
    merchRuleFormKey,
    entityId,
    merchRuleProduct,
    isMerchRuleFormSubmitting,
    selectedRule,
  } = useEditMerchRule(shopId, permittedRouteMap);

  const { selectedMerchRule } = useGetSelectedMerchRule({ selectedRule });

  const { categoryFilterRule } = useEditCategoryPage({
    shopId,
    permittedRouteMap,
  });
  const isMerchRulesAiTagsEnabled = useIsFeaturePermitted(ShopFeature.MerchandisingRulesAiTags);
  const { navigateToVisualEditorRoute } = useNavigateToVisualEditorRoute({
    route: permittedRouteMap?.visualEditor,
  });

  if (!selectedMerchRule) {
    return null;
  }

  return (
    <CollapseDrawer
      open
      className={className}
      onClose={() => navigateToVisualEditorRoute({ shopId })}
    >
      <EditMerchandisingRuleContainer
        key={merchRuleFormKey}
        shopId={shopId}
        mode={Mode.edit}
        entityId={entityId}
        rule={selectedMerchRule ?? undefined}
        predefinedProduct={merchRuleProduct}
        isAiTagsEnabled={isMerchRulesAiTagsEnabled}
        onSave={submitEditMerchRuleForm}
        onClose={closeMerchandisingRulesDrawer}
        isSubmitting={isMerchRuleFormSubmitting}
        categoryFilterRule={categoryFilterRule}
        featureToggles={featureToggles}
      />
    </CollapseDrawer>
  );
};
